"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureControlLimitSubHeading = exports.FeatureControlLimit = void 0;
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = require("../styled-components");
const FeatureControlLimitChart_1 = require("./FeatureControlLimitChart");
const __1 = require("../");
const Statistics_1 = require("./Statistics");
const FeatureControlLimit = (props) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const { onLoadClick, errors, ...chartProps } = props;
    const [featureControlLimitChartValues, setFeatureControlLimitChartValues] = (0, react_1.useState)(chartProps);
    (0, react_1.useEffect)(() => {
        if (errors === undefined || !("featureControlLimitSettings" in errors)) {
            setFeatureControlLimitChartValues(chartProps);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errors, props.values, props.loading]);
    const deviations = ((_a = props.results) === null || _a === void 0 ? void 0 : _a.map((r) => { var _a; return (_a = r.deviation) !== null && _a !== void 0 ? _a : r.actual - (r.nominal || 0); })) || [];
    return (react_1.default.createElement("section", null,
        react_1.default.createElement(exports.FeatureControlLimitSubHeading, { text: t("heading-Limits") },
            react_1.default.createElement(LoadButton, { type: "button", onClick: onLoadClick, disabled: props.loading, title: t("tooltip-loadResults") }, props.loading ? react_1.default.createElement(__1.Busy, { show: true }) : t("button-loadResults"))),
        react_1.default.createElement(FeatureControlLimitChart_1.FeatureControlLimitChart, { ...featureControlLimitChartValues }),
        react_1.default.createElement(Statistics_1.Statistics, { deviations: deviations, upperTolerance: props.upperTolerance, lowerTolerance: props.lowerTolerance })));
};
exports.FeatureControlLimit = FeatureControlLimit;
const FeatureControlLimitSubHeading = ({ text, children }) => (react_1.default.createElement(Header, null,
    react_1.default.createElement(HeaderRow, null,
        react_1.default.createElement(LimitsHeading, { as: "h3" }, text),
        children),
    react_1.default.createElement(__1.Separator, { noSpace: true })));
exports.FeatureControlLimitSubHeading = FeatureControlLimitSubHeading;
const Header = styled_components_1.styled.header `
  display: flex;
  flex-wrap: nowrap;
  padding: 0 ${({ theme }) => theme.spacing};
  flex-direction: column;
  align-self: stretch;
  height: 50px;
  margin-top: -${({ theme }) => theme.spacing};
  margin-bottom: ${({ theme }) => theme.spacing};
`;
const HeaderRow = styled_components_1.styled.div `
  display: flex;
  flex-wrap: nowrap;
  height: 50px;
`;
const LimitsHeading = (0, styled_components_1.styled)(__1.Heading) `
  flex: 1 1 100%;
  font-size: 1.2rem;
  height: 30px;
  padding: 0 ${({ theme }) => theme.spacing};
`;
const LoadButton = (0, styled_components_1.styled)(__1.Button) `
  flex: 0 0 auto;
  margin: 10px;
  /* centre the Busy spinner */
  div {
    flex-grow: 0;
  }
`;
//# sourceMappingURL=index.js.map